var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import utils from "../helpers/indoorHelper";
import { useUserInfo } from "../../hooks";
var VenueEdit = lazy(function () { return import("../../features/venueDetails/components/VenueEdit"); });
var VenueAddInfo = lazy(function () { return import("../../features/venueDetails/VenueAddInfo"); });
var FileUpload = lazy(function () { return import("../../features/fileUpload/FileUpload"); });
var Order3dMap = lazy(function () { return import("../../components/Order3DMaps"); });
var FirstPage = lazy(function () { return import("../../pages/FirstPage/FirstPage"); });
var PrcWizard = lazy(function () { return import("../../components/PRC/prcWizard/PrcWizard"); });
var NoMapViewCard = lazy(function () { return import("../../components/noMapViewCard/NoMapViewCard"); });
var RootRoute = function () {
    var pathname = useLocation().pathname;
    var _a = useUserInfo(), realm = _a.realm, email = _a.email;
    var isRouteAllowed = utils.isRealmAllowed(realm);
    var isInternalUser = email ? email.includes("@here.com") : false;
    return (_jsxs(Switch, { children: [_jsx(Redirect, { from: "/:url*(/+)", to: pathname.slice(0, -1) }), _jsx(Route, __assign({ exact: true, path: "/" }, { children: _jsx(FirstPage, {}) })), _jsx(Route, { path: "/edit", render: function (props) {
                    var _a, _b;
                    return (_jsxs(_Fragment, { children: [((_b = (_a = props === null || props === void 0 ? void 0 : props.location) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.isMigration) && _jsx(PrcWizard, {}), _jsx(VenueEdit, {})] }));
                } }), _jsxs(Route, __assign({ path: "/addInfo" }, { children: [_jsx(PrcWizard, {}), _jsx(VenueAddInfo, {})] })), _jsxs(Route, __assign({ path: "/upload" }, { children: [_jsx(PrcWizard, {}), _jsx(FileUpload, {})] })), _jsx(Route, __assign({ path: "/mapOrders" }, { children: _jsx(VenueEdit, {}) })), _jsx(Route, { path: "/internalTools", render: function () {
                    if (isInternalUser) {
                        return _jsx(FirstPage, {});
                    }
                    return _jsx(Redirect, { to: "/" });
                } }), _jsx(Route, __assign({ path: "/noMapViewCard" }, { children: _jsx(NoMapViewCard, {}) })), _jsx(Route, { path: "/order3dmaps", render: function () {
                    if (isRouteAllowed) {
                        return _jsx(Order3dMap, {});
                    }
                    return _jsx(Redirect, { to: "/" });
                } })] }));
};
export default RootRoute;
